import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { getVisiblePaginationPages } from "../PaginationBar";

type Props = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

const ICON_BOX =
  "flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white";

export function ListPagination({
  currentPage,
  totalPages,
  onPageChange,
}: Props) {
  const pages = getVisiblePaginationPages(currentPage, totalPages);
  if (totalPages < 1) return null;

  const isFirst = currentPage <= 1;
  const isLast = currentPage >= totalPages;

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <div className={ICON_BOX}>
        {isFirst ? (
          <ChevronsLeft className="h-5 w-5 text-slate-300" />
        ) : (
          <button
            type="button"
            aria-label="Primeira página"
            onClick={() => onPageChange(1)}
          >
            <ChevronsLeft className="h-5 w-5 text-slate-500" />
          </button>
        )}
      </div>

      <div className={ICON_BOX}>
        {isFirst ? (
          <ChevronLeft className="h-5 w-5 text-slate-300" />
        ) : (
          <button
            type="button"
            aria-label="Página anterior"
            onClick={() => onPageChange(currentPage - 1)}
          >
            <ChevronLeft className="h-5 w-5 text-slate-500" />
          </button>
        )}
      </div>

      {pages.map((page) => {
        const isActive = page === currentPage;
        return (
          <button
            key={page}
            type="button"
            onClick={() => onPageChange(page)}
            className={`flex h-10 min-w-10 items-center justify-center rounded-lg border px-2 text-sm font-semibold no-underline transition ${
              isActive
                ? "border-orange-500 bg-orange-500 text-white shadow-sm hover:bg-orange-600"
                : "border-slate-200 bg-white text-slate-800 hover:border-slate-300 hover:bg-slate-50"
            }`}
          >
            {page}
          </button>
        );
      })}

      <div className={ICON_BOX}>
        {isLast ? (
          <ChevronRight className="h-5 w-5 text-slate-300" />
        ) : (
          <button
            type="button"
            aria-label="Próxima página"
            onClick={() => onPageChange(currentPage + 1)}
          >
            <ChevronRight className="h-5 w-5 text-slate-500" />
          </button>
        )}
      </div>

      <div className={ICON_BOX}>
        {isLast ? (
          <ChevronsRight className="h-5 w-5 text-slate-300" />
        ) : (
          <button
            type="button"
            aria-label="Última página"
            onClick={() => onPageChange(totalPages)}
          >
            <ChevronsRight className="h-5 w-5 text-slate-500" />
          </button>
        )}
      </div>
    </div>
  );
}
